import { Type } from 'class-transformer'
import { SupporterType } from './SupporterType'

export class SupporterResponse {
  @Type(() => SupporterType)
  data: SupporterType[]

  page: number
}
